var _defs, _rect, _rect2, _g, _text, _text2, _text3, _text4, _text5, _path, _line, _g2, _g3, _g4, _g5, _g6, _text6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiAgentEscalationLadder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 630",
    width: 1200,
    height: 630,
    role: "img",
    "aria-label": "The escalation ladder: four rungs of AI agent autonomy from observe to autonomous, with a human approval gate before the top rung",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "elBg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#121020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#171523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121020"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "elGlow",
    cx: 0.72,
    cy: 0.45,
    r: 0.62
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b7a4e6",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7a4e6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "elAi",
    x1: 0,
    y1: 1,
    x2: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fd8f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#b7a4e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f7fd0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "elGold",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe9a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f6cf6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2b24a"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "elSoft",
    x: "-40%",
    y: "-40%",
    width: "180%",
    height: "180%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  })), /*#__PURE__*/React.createElement("style", null, "\n      .h  { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:800; fill:#f4f0fc; }\n      .s  { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:600; fill:#b8b2cc; }\n      .eyebrow { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:700; fill:#cfc3ee; letter-spacing:4px; }\n      .rung { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:700; fill:#e2d9f5; }\n      .num  { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:800; fill:#121020; }\n      .gate { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:800; fill:#f6cf6a; letter-spacing:2px; }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 630,
    fill: "url(#elBg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 630,
    fill: "url(#elGlow)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#2a2547",
    strokeWidth: 1,
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 90 H1200 M0 180 H1200 M0 270 H1200 M0 360 H1200 M0 450 H1200 M0 540 H1200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 0 V630 M300 0 V630 M450 0 V630 M600 0 V630 M750 0 V630 M900 0 V630 M1050 0 V630"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 126,
    className: "eyebrow",
    fontSize: 20
  }, "ESCALATION DESIGN")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 200,
    className: "h",
    fontSize: 60
  }, "When should")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 268,
    className: "h",
    fontSize: 60
  }, "the agent stop?")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 318,
    className: "s",
    fontSize: 24
  }, "Set the rung by reversibility, not by vibes.")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 588,
    className: "s",
    fontSize: 20,
    opacity: 0.8
  }, "BOSSDROP.AI")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M620 450 H730 V390 H855 V325 H980 V250 H1105",
    fill: "none",
    stroke: "#4c4380",
    strokeWidth: 2,
    strokeDasharray: "7 9",
    opacity: 0.9
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 520,
    x2: 1130,
    y2: 520,
    stroke: "#342e57",
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 450,
    width: 110,
    height: 70,
    rx: 10,
    fill: "#1d1a2e",
    stroke: "#4c4380",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 745,
    y: 390,
    width: 110,
    height: 130,
    rx: 10,
    fill: "#211d36",
    stroke: "#5b5095",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 870,
    y: 325,
    width: 110,
    height: 195,
    rx: 10,
    fill: "#262040",
    stroke: "#6b5fae",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 995,
    y: 250,
    width: 110,
    height: 270,
    rx: 10,
    fill: "url(#elAi)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 995,
    y: 250,
    width: 110,
    height: 270,
    rx: 10,
    fill: "none",
    stroke: "#8fd8f0",
    strokeWidth: 2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 675,
    cy: 476,
    r: 15,
    fill: "#cfc3ee"
  }), /*#__PURE__*/React.createElement("text", {
    x: 675,
    y: 482,
    textAnchor: "middle",
    className: "num",
    fontSize: 16
  }, "1"), /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 416,
    r: 15,
    fill: "#cfc3ee"
  }), /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 422,
    textAnchor: "middle",
    className: "num",
    fontSize: 16
  }, "2"), /*#__PURE__*/React.createElement("circle", {
    cx: 925,
    cy: 398,
    r: 15,
    fill: "#cfc3ee"
  }), /*#__PURE__*/React.createElement("text", {
    x: 925,
    y: 404,
    textAnchor: "middle",
    className: "num",
    fontSize: 16
  }, "3"), /*#__PURE__*/React.createElement("circle", {
    cx: 1050,
    cy: 300,
    r: 15,
    fill: "#8fd8f0"
  }), /*#__PURE__*/React.createElement("text", {
    x: 1050,
    y: 306,
    textAnchor: "middle",
    className: "num",
    fontSize: 16
  }, "4"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    textAnchor: "middle",
    className: "rung",
    fontSize: 17
  }, /*#__PURE__*/React.createElement("text", {
    x: 675,
    y: 550
  }, "Observe"), /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 550
  }, "Advise"), /*#__PURE__*/React.createElement("text", {
    x: 925,
    y: 550
  }, "Approve"), /*#__PURE__*/React.createElement("text", {
    x: 1050,
    y: 550
  }, "Autonomous"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 925,
    cy: 325,
    r: 30,
    fill: "url(#elGold)",
    filter: "url(#elSoft)",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 925,
    cy: 325,
    r: 26,
    fill: "url(#elGold)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 915,
    y: 314,
    width: 7,
    height: 22,
    rx: 2,
    fill: "#121020"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 928,
    y: 314,
    width: 7,
    height: 22,
    rx: 2,
    fill: "#121020"
  }), /*#__PURE__*/React.createElement("text", {
    x: 925,
    y: 282,
    textAnchor: "middle",
    className: "gate",
    fontSize: 15
  }, "STOP &amp; ASK"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    stroke: "#8fd8f0",
    strokeWidth: 2.5,
    fill: "none",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1118 500 V 232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110 244 L1118 228 L1126 244"
  }))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 1150,
    y: 372,
    textAnchor: "middle",
    className: "s",
    fontSize: 14,
    transform: "rotate(-90 1150 372)"
  }, "autonomy")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAgentEscalationLadder);
export default __webpack_public_path__ + "static/media/ai-agent-escalation-ladder.7fc83054952f027520cda025d7d0686d.svg";
export { ForwardRef as ReactComponent };